module.exports = __webpack_public_path__ + "static/media/cucarachita.33c914ca.jpg";